// extracted by mini-css-extract-plugin
module.exports = {"s1xzj44a":"s1xzj44a"};